import 'flowbite';
import './script/configs';
import './script/fancybox';
import './script/mask';
import './script/slick-banner';
import './script/slick-card';
import './script/whatsapp';
import { Tabs } from "flowbite";

document.addEventListener('DOMContentLoaded',function(){
    const $tabs = document.querySelectorAll('#tabExample');

    if(!$tabs.length) return

    // create an array of objects with the id, trigger element (eg. button), and the content element
    const tabElements = [
        {
            id: 'estagio',
            triggerEl: document.querySelector('#estagio-tab'),
            targetEl: document.querySelector('#estagio')
        },
        {
            id: 'localizacao',
            triggerEl: document.querySelector('#localizacao-tab'),
            targetEl: document.querySelector('#localizacao')
        },
        {
            id: 'contato',
            triggerEl: document.querySelector('#contato-tab'),
            targetEl: document.querySelector('#contato')
        }
    ];
    
    
    // options with default values
    const options = {
        defaultTabId: 'settings',
        activeClasses: 'active__tab',
        inactiveClasses: 'text-gray-500 hover:text-gray-600 dark:text-gray-400 border-gray-100 hover:border-gray-300 dark:border-gray-700 dark:hover:text-gray-300'
    };
    
    const tabs = new Tabs(tabElements, options);
    
    tabs.getActiveTab()
});
